import { PRIVACY_KEY, USE_KEY } from './info';

export const TermType = {
  PRIVACY: '개인정보처리방침',
  USE: '서비스 이용약관',
  MARKETING: '마케팅수신동의',
  REFUND: '환불규정',
} as const;

export type TermType = keyof typeof TermType;

export type TermOption = {
  label: string;
  term: TermType;
  value: string;
};

export const Terms: TermOption[] = [
  { label: '개인정보 처리방침', term: 'PRIVACY', value: PRIVACY_KEY },
  { label: '서비스 이용약관', term: 'USE', value: USE_KEY },
] as const;
